/** Canonical app origin for absolute URLs (emails, impersonation). Falls back to current page origin. */
export const getAppOrigin = () =>
  (process.env.REACT_APP_APP_URL || "").replace(/\/$/, "") ||
  (typeof window !== "undefined" ? window.location.origin.replace(/\/$/, "") : "");

const MAIN_MARKETING_HOSTS = new Set([
  "fractolabs.com",
  "www.fractolabs.com",
  "localhost",
  "127.0.0.1",
]);

const FRACTOLABS_APEX = "fractolabs.com";

/** Legacy subdomain → root landing key for `/`. */
export const SUBDOMAIN_ROOT_LANDING = {
  partner: "partner",
  roofing: "roofing",
  inbnd: "realEstate",
  ai: "loginRedirect",
};

export function getHostname() {
  return typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
}

export function isMainMarketingHost(hostname = getHostname()) {
  return MAIN_MARKETING_HOSTS.has(hostname);
}

/** Returns subdomain label for *.fractolabs.com, or null for apex/www/non-fractolabs hosts. */
export function getFractoLabsSubdomain(hostname = getHostname()) {
  const normalized = hostname.toLowerCase();
  if (normalized === FRACTOLABS_APEX || normalized === `www.${FRACTOLABS_APEX}`) {
    return null;
  }
  if (!normalized.endsWith(`.${FRACTOLABS_APEX}`)) {
    return null;
  }
  const subdomain = normalized.slice(0, -(FRACTOLABS_APEX.length + 1));
  if (!subdomain || subdomain.includes(".")) {
    return null;
  }
  return subdomain;
}

export function hasLandingUnlockParam(search = "") {
  const normalized = search.startsWith("?") ? search.slice(1) : search;
  return new URLSearchParams(normalized).has("l");
}

/**
 * Resolves which root landing to show at `/`.
 * @returns {"main"|"partner"|"roofing"|"realEstate"|"loginRedirect"|"stub"}
 */
export function resolveRootLandingKey(
  hostname = getHostname(),
  search = typeof window !== "undefined" ? window.location.search : "",
  storedLeadId = null,
) {
  if (isMainMarketingHost(hostname)) {
    return "main";
  }

  const subdomain = getFractoLabsSubdomain(hostname);
  let key;
  if (subdomain === null) {
    key = "stub";
  } else {
    key = SUBDOMAIN_ROOT_LANDING[subdomain] ?? "stub";
  }

  if (key === "stub" && (hasLandingUnlockParam(search) || Boolean(storedLeadId))) {
    return "main";
  }
  return key;
}
